import { render, staticRenderFns } from "./CpcToolingDetailMaintain.vue?vue&type=template&id=28d8007b&scoped=true"
import script from "./CpcToolingDetailMaintain.vue?vue&type=script&lang=js"
export * from "./CpcToolingDetailMaintain.vue?vue&type=script&lang=js"
import style0 from "./CpcToolingDetailMaintain.vue?vue&type=style&index=0&id=28d8007b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d8007b",
  null
  
)

export default component.exports